import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { formatPortalCopyDeep } from '../common/formatCopy';

/**
 * Default copy for the access-request flow, taken from the design refs images/search_1 / request_1 / success_1 / subbroker_1
 * (hardcoded English at demo stage, no i18n)
 * - {brokerName} defaults to brand.name, {email} to the email carried over from the login page; both overridable via copyParams
 * - {entityName} / {count} / {query} are runtime params, substituted by components at render time
 */

/** Default searchable sub-broker entity mock list (demo; first line name, second line country) */
export var DEFAULT_ACCESS_ENTITIES = [{
  id: 'entity-1',
  name: 'entity name 1',
  location: 'United Kingdom'
}, {
  id: 'entity-2',
  name: 'entity name 2',
  location: 'United Kingdom'
}, {
  id: 'entity-3',
  name: 'entity name 3',
  location: 'Portugal'
}];
/** Demo country options for the sub-broker register form */

export var DEFAULT_ACCESS_COUNTRIES = ['United Kingdom', 'Ireland', 'Portugal'];
/** Demo checkable product list for the sub-broker register form (interaction only, nothing is submitted) */

export var DEFAULT_ACCESS_PRODUCTS = ['Product 1', 'Product 2'];
var DEFAULT_ACCESS_FLOW_COPY = {
  stepper: {
    steps: ['Find your agency', 'Your details', 'Request sent']
  },
  search: {
    banner: "We didn't recognise {email}. If your agency already works with {brokerName}, find it below to join your team — otherwise you can register a new one.",
    searchPlaceholder: 'Search by legal entity',
    searchText: 'Search',
    matchCountText: "{count} agencies match '{query}'",
    continueText: 'Continue with {brokerName}',
    cantFindTitle: "Can't find your agency?",
    cantFindDesc: "You must first contact the Agency and ask them for access to Jove's PI combined product. They'll confirm your agency's details and send you an invite.",
    contactText: 'Contact {brokerName}',
    registerHint: 'Already working with the Agency but not on Jove yet?',
    registerText: 'Register a new agency instead'
  },
  member: {
    agencyTag: '{brokerName} agency',
    changeText: 'Change',
    formTitle: 'Your details',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    notesLabel: 'Anything else we should know?',
    banner: "This isn't an invite. {entityName}'s admin and {brokerName} will both review your request before you get access.",
    submitText: 'Send request',
    afterSubmitTitle: 'What happens after you submit',
    afterSubmitItems: ["Your request goes to {entityName}'s admin and to {brokerName} at the same time.", "They confirm you're part of the agency and review your details.", "You're emailed the moment you're approved, and can log in straight away."],
    contactHint: 'Not sure which applies to you?',
    contactLinkText: 'Contact {brokerName}'
  },
  subBroker: {
    label: 'New agency',
    title: 'Request access to Jove product through {brokerName}',
    subtitle: "For agencies that already work with {brokerName} but haven't been added to Jove yet — a few details so {brokerName} can set you up and get you quoting.",
    banner: 'No TOBA or signature required to get started. You can build quotes as soon as you submit — {brokerName} will review your agency before any policy can be bound.',
    entityTitle: 'Entity details',
    countryLabel: 'Country',
    entityNameLabel: 'Entity name',
    contactNameLabel: 'Contact name',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    commissionLabel: 'Requested commission rate (%)',
    commissionHint: 'Final rate is confirmed by {brokerName} as part of approval.',
    productTitle: 'Product access request',
    productDesc: "Choose the products you'd like to quote. {brokerName} confirms which you're approved for.",
    membersTitle: 'Members',
    membersDesc: "Add anyone else at your agency who'll need access once you're approved — you can also invite people later.",
    memberNameLabel: 'Name',
    memberEmailLabel: 'Email',
    memberPhoneLabel: 'Phone',
    addMemberText: 'Add member',
    submitText: 'Submit for approval',
    footnote: "You'll be able to quote immediately — binding unlocks once {brokerName} approves your agency.",
    backText: 'Back to agency search'
  },
  success: {
    dialogTitle: 'Request sent',
    memberHeading: 'Request sent',
    subBrokerHeading: 'Submitted for approval',
    memberBody: "We've let {entityName}'s admin and {brokerName} know you'd like to join. You'll get an email the moment you're approved.",
    subBrokerBody: "We've let {brokerName} know you'd like to join. You'll get an email the moment you're approved.",
    badge: 'Self-registered — awaiting approval',
    reviewHint: 'Typically reviewed within 1 business day.',
    backText: 'Back to {brokerName} portal'
  }
};
/** Per-project copy overrides: all projects share the design copy for now; add differences here when needed */

var PORTAL_ACCESS_COPY_BY_PROJECT = {};
export var resolvePortalAccessFlowConfig = function resolvePortalAccessFlowConfig(props) {
  var projectType = props.projectType,
      brand = props.brand,
      email = props.email,
      entities = props.entities,
      copy = props.copy,
      copyParams = props.copyParams;
  var byProject = PORTAL_ACCESS_COPY_BY_PROJECT[projectType] || {};
  var merged = {
    stepper: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ACCESS_FLOW_COPY.stepper), byProject.stepper), copy === null || copy === void 0 ? void 0 : copy.stepper),
    search: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ACCESS_FLOW_COPY.search), byProject.search), copy === null || copy === void 0 ? void 0 : copy.search),
    member: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ACCESS_FLOW_COPY.member), byProject.member), copy === null || copy === void 0 ? void 0 : copy.member),
    subBroker: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ACCESS_FLOW_COPY.subBroker), byProject.subBroker), copy === null || copy === void 0 ? void 0 : copy.subBroker),
    success: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ACCESS_FLOW_COPY.success), byProject.success), copy === null || copy === void 0 ? void 0 : copy.success)
  };

  var params = _objectSpread({
    brokerName: (brand === null || brand === void 0 ? void 0 : brand.name) || 'Jove',
    email: email || ''
  }, copyParams);

  return {
    entities: entities !== null && entities !== void 0 && entities.length ? entities : DEFAULT_ACCESS_ENTITIES,
    copy: formatPortalCopyDeep(merged, params)
  };
};